<router-outlet></router-outlet>
<ngx-spinner
  bdColor="rgba(0, 0, 0, 0.1)"
  size="medium"
  color="#fff"
  type="square-jelly-box"
  [zIndex]="9999"
  [fullScreen]="true">
</ngx-spinner>